module.exports = __webpack_public_path__ + "static/media/logo192.c11f62c3.png";